import React from "react";
import { Field, Formik } from "formik";
import { connect } from "react-redux";
import { compose } from "recompose";
import * as Yup from "yup";
import { useGoogleReCaptcha } from "react-google-recaptcha-v3";

import Input from "components/Input";
import Button from "components/Button";
import AuthModule from "modules/auth";
import ROUTES from "config/routes";

function SignInForm(props) {
  const { isFetching } = props;

  const { executeRecaptcha } = useGoogleReCaptcha();

  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      validationSchema={Yup.object().shape({
        email: Yup.string().email("Invalid email").required("Required"),
        password: Yup.string()
          .min(6, "Too Short!")
          .max(16, "Too Long!")
          .required("Required"),
      })}
      onSubmit={async (values) => {
        const token = await executeRecaptcha("login");

        const sendData = { ...values, ["g-recaptcha-response"]: token };

        props.signIn(sendData);
      }}
    >
      {(props) => (
        <form onSubmit={props.handleSubmit}>
          <div className="field-wrap">
            <Field
              name="email"
              type="email"
              placeholder="Email Address"
              component={Input}
              isRequired={true}
            />
          </div>
          <div className="field-wrap">
            <Field
              name="password"
              type="password"
              placeholder="Password"
              component={Input}
              icon="password"
              isRequired={true}
            />
          </div>
          <div className="field-wrap text-center">
            <Button bgColor={null} width="auto" to={ROUTES.restorePass}>
              Forgot password?
            </Button>
          </div>
          <div className="text-center">
            <Button bgColor="green" type="submit" showLoader={isFetching}>
              Login
            </Button>
          </div>
        </form>
      )}
    </Formik>
  );
}

export default compose(
  connect(
    (state) => ({
      isFetching: state.auth.isFetching,
      isFetched: state.auth.isFetched,
    }),
    {
      signIn: AuthModule.signIn,
    }
  )
)(SignInForm);
